import { render, staticRenderFns } from "./RegistrationSlip.vue?vue&type=template&id=50505919&scoped=true"
import script from "./RegistrationSlip.vue?vue&type=script&lang=js"
export * from "./RegistrationSlip.vue?vue&type=script&lang=js"
import style0 from "./RegistrationSlip.vue?vue&type=style&index=0&id=50505919&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50505919",
  null
  
)

export default component.exports